export default __webpack_public_path__ + "static/media/white_paper.71b2d765.pdf";